export default function(categories, category) {
  // Don't show child categories for the Academy page
  if(category.id === 155){
    return false;
  }
  return categories.some(cat => cat.parentId === category.id);
}
